import React from 'react'

import './NoDataMessage.scss'

const NoDataMessage = () => {
    return (
        <div className="NoDataMessage__cont">
            <div className="message_cont">No Data Available.</div>
        </div>
    )
}

export default NoDataMessage
